// extracted by mini-css-extract-plugin
module.exports = {"varSpUp4":"2rem","varSpUp2":"1.5rem","varTextSubtle":"var(--tkww-union-color-text-subtle, var(--tkww-union-color-neutral-500, #51545C))","text":"text--a3c6f"};